import CryptoJs from 'crypto-js'
export const encrypt = (data, keyValue) => {
    let key = CryptoJs.enc.Utf8.parse(keyValue || 'nqio8Mem5oDNNBxOStIAlIsxrtWAx/c8')
    let srcs = CryptoJs.enc.Utf8.parse(JSON.stringify(data))
    let encrypted = CryptoJs.AES.encrypt(srcs, key, { mode: CryptoJs.mode.ECB, padding: CryptoJs.pad.Pkcs7 })
    return encrypted.toString()
}